import React from "react";
import { useSignOut } from "../auth/use-sign-out";

const LogoutButton = () => {
  const signOut = useSignOut();
  return (
    <button className="btn btn-danger btn-block" onClick={signOut}>
      Log Out
    </button>
  );
};

export default LogoutButton;
